module.exports = __webpack_public_path__ + "img/other4.57ef6252.png";